import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getStickyNotes({ commit }, data) {
      try {
        const url = `/periods/${data.periodId}/unity/${data.unityId}/sticky-notes`
        const response = await api.get(url)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
    async deleteStickyNote({ commit }, data) {
      try {
        const url = `/periods/${data.periodId}/unity/${data.unityId}/sticky-notes/${data.stickyId}`
        return await api.delete(url)
      } catch (error) {
        throw error
      }
    },
    async updateStikyNote({ commit }, data) {
      try {
        const url = `/periods/${data.periodId}/unity/${data.unityId}/sticky-notes/${data.stickyId}`
        return await api.put(url, data.sticky)
      } catch (error) {
        throw error
      }
    },
    async insertStickyNote({ commit }, data) {
      try {
        const url = `/periods/${data.periodId}/unity/${data.unityId}/sticky-notes`
        return await api.post(url, data.sticky)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
